import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import CarouselDots from '../../shared/Carousel/CarouselDots';
import CarouselThumbs from '../../shared/Carousel/CarouselThumbs';

function MobileCarouselControl(props) {
  const { goToSlide, classicLayout, hasMultipleAssets, currentAssetIndex } = props;

  useEffect(() => {
    goToSlide(currentAssetIndex);
  }, [currentAssetIndex]);

  if (!hasMultipleAssets) {
    return null;
  }

  if (classicLayout) {
    return <CarouselThumbs { ...props } onClickThumbnail={ index => goToSlide(index) } />;
  }

  return <CarouselDots { ...props } />;
}

MobileCarouselControl.propTypes = {
  classicLayout: PropTypes.bool,
  goToSlide: PropTypes.func,
  hasMultipleAssets: PropTypes.bool,
  currentAssetIndex: PropTypes.bool
};

export default MobileCarouselControl;
